import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import React, { Component, FC, ReactElement } from 'react';

import { withSentryHub } from '../services/sentryService';

export type SentryErrorBoundaryProps = {
  fallbackRender: (
    props: FallbackProps,
  ) => ReactElement<unknown, string | FC | typeof Component> | null;
};

const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ children, fallbackRender }) => {
  const handleError = (error: Error) => {
    // 1- Simple approach : capture error with no tag
    // ------------------------
    withSentryHub().captureException(error);
    // ------------------------
    // 2- Approach adding a tag
    // ------------------------
    // withSentryHub().captureException(error, {
    //   // If you need to send things specific to this error on top of the error
    //   // itself then use this captureContext
    //   captureContext: (scope) => scope.setTags({ type: 'errorBoundary' }),
    // });
    // ------------------------
  };

  return (
    <ErrorBoundary fallbackRender={fallbackRender} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};

export default SentryErrorBoundary;
